import MuiButton, { ButtonProps } from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const StyledButton = styled(MuiButton)<ButtonProps>(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  borderRadius: 16,
  fontWeight: 'bold',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: theme.palette.primary.light,
  },
}));

export default function Button(props: any) {
  return (
    <StyledButton disableElevation {...props}>
      {props.children}
    </StyledButton>
  );
}
